import React from "react";
import { NumberField } from "@refinedev/antd";
import { Typography, Card, Checkbox, Popover, InputNumber, Button, Tag } from "antd";
import noImage from "@/assets/img/no-img.png";
import { ApiOutlined, ShopOutlined } from "@ant-design/icons";
import { Flex, theme } from "antd";

const { Text } = Typography;

interface LinkedProductCardProps {
  item?: any;
  linkedID: string;
  isHovered?: boolean;
  isSelected?: boolean;
  handleSelectProduct: (linkedID: string) => void;
  stores?: any[];
  selectedProducts?: any;
  setSelectedProductData?: any;
  t?: any;
}

export const LinkedProductCard: React.FC<LinkedProductCardProps> = React.memo(
  ({
    item,
    linkedID,
    isHovered,
    isSelected,
    handleSelectProduct,
    selectedProducts,
    setSelectedProductData,
    t,
  }) => {
    const { token } = theme.useToken();
    const styleColorSecondary = { color: token.colorTextSecondary };

    const stores: any = [];
    return (
      <Card
        className="linked-product-card"
        style={{
          backgroundColor: isHovered ? token.colorBgBase : token.colorFillAlter,
          overflow: "hidden",
        }}
        styles={{
          body: {
            padding: 0,
          },
          cover: {
            position: "relative",
          },
          actions: {
            marginTop: "auto",
          },
        }}
      >
        <Card.Meta
          title={
            <>
              <Flex
                className={`${
                  isHovered && !isSelected && !item.vendorSku
                    ? "linked-product-card__header--green"
                    : "linked-product-card__header--none"
                }`}
                vertical
                align="center"
                justify="center"
                onClick={() => handleSelectProduct(linkedID)}
              >
                <Button
                  onClick={(e) => { e.stopPropagation(); handleSelectProduct(linkedID); }}
                  iconPosition="end"
                  icon={<ApiOutlined />}
                >
                  {t("linkedProducts.modal.link")}
                </Button>
              </Flex>

              <Flex
                className={`${
                  isSelected
                    ? "linked-product-card__header--gray"
                    : "linked-product-card__header--none "
                }`}
                vertical
                align="center"
                justify="center"
              >
                <Text
                  style={{
                    ...styleColorSecondary,
                    fontWeight: "400",
                    textAlign: "center",
                    width: 85,
                    textWrap: "pretty",
                  }}
                >
                  {t("linkedProducts.modal.linkedToThisProduct")}
                </Text>
              </Flex>

              <Flex
                className={`${
                  item.vendorSku
                    ? "linked-product-card__header--gray"
                    : "linked-product-card__header--none "
                }`}
                vertical
                align="center"
                justify="center"
              >
                <Text
                  style={{
                    ...styleColorSecondary,
                    fontWeight: "400",
                    textAlign: "center",
                    width: 80,
                    textWrap: "pretty",
                  }}
                >
                  {t("linkedProducts.modal.linkedTo")}{" "}
                  <span style={{ userSelect: "text" }}>{item?.vendorSku}</span>{" "}
                  {/* <Text copyable={{ text: item?.vendorSku }} /> */}
                </Text>
              </Flex>

              {/* <Flex>
                <Popover
                  content={stores.map((store: any) => (
                    <span key={store?.id}>
                      {store.name}
                      <br />
                    </span>
                  ))}
                >
                  <ShopOutlined
                    style={{
                      color: isSelected ? token.colorPrimary : "",
                      marginLeft: "auto",
                    }}
                  />
                </Popover>
              </Flex> */}
            </>
          }
          description={
            <>
              <img
                src={item?.image || noImage}
                style={{ width: "100%", objectFit: "cover", borderRadius: 8 }}
              />
              {/* <Flex
                justify={
                  selectedProducts?.length > 1 ? "space-between" : "start"
                }
                align="end"
              >
                {selectedProducts?.length > 1 && isSelected && (
                  <Flex vertical>
                    <span>Conversion</span>
                    <InputNumber
                      className="no-arrows"
                      style={{ width: 55 }}
                      onClick={(e) => e.stopPropagation()}
                      placeholder="Factor"
                      defaultValue={item?.factor || 1}
                      min="0"
                      step="0.5"
                      onChange={(value) => {
                        const id = linkedID;
                        setSelectedProductData((prev: any) => ({
                          ...prev,
                          [id]: {
                            sku: id,
                            factor: item?.factor || value,
                            image: item?.image,
                            name: item?.name,
                          },
                        }));
                      }}
                    />
                  </Flex>
                )}
              </Flex> */}
              <Text
                strong
                style={{
                  margin: "8px 0 0 8px",
                  display: "block",
                }}
              >
                {item?.manufacturer}
              </Text>
              <Flex align="center" gap={6} style={{ margin: "8px" }}>
                <NumberField
                  value={(item?.avgPrice || 0) * (1 + (item?.tax_class_id ?? 0) / 100)}
                  options={{
                    style: "currency",
                    currency: "ARS",
                  }}
                />
                <Tag
                  color="default"
                  style={{ marginInlineStart: 0, fontSize: 10, padding: "0 4px", lineHeight: "18px" }}
                >
                  {(item?.tax_class_id ?? 0) > 0 ? "c/IVA" : "s/IVA"}
                </Tag>
              </Flex>

              <Text
                strong
                style={{
                  ...styleColorSecondary,
                  padding: "0 8px 8px",
                  textWrap: "pretty",
                  display: "block",
                  fontSize: token.fontSizeSM,
                }}
              >
                {item.name}
              </Text>
            </>
          }
        />
      </Card>
    );
  },
);
